// @flow

import type { Saga } from 'redux-saga';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import clientConfig from '~/../parameters/client/config';
import ApiNotificationsParams from '~/sdk/notifications/email/ApiNotificationsParams';
import mapResolvedParams from './adapters/resolvedParamsAdapter';
import { notificationApiParamsSelector } from '../selectors';
import { setNotificationResolvedParams } from './actions';
import { openSnackbarError } from '../Snackbar/actions';
import { RESOLVE_NOTIFICATION_PARAMS } from './actionTypes';

const notificationsParamsApi = new ApiNotificationsParams(clientConfig.notificationsParamsApi);

export function* resolveNotificationParamsSaga({ payload }: TrovitAction): Saga<void> {
  const { alertControlToken } = payload;
  const apiParams = yield select(notificationApiParamsSelector);
  /* eslint-disable-next-line camelcase */
  const { country_code, vertical_id } = apiParams;
  const queryParams = { country_code, vertical_id };

  try {
    const apiResolvedParams = yield call(
      [notificationsParamsApi, notificationsParamsApi.getNotificationsParams],
      queryParams,
      alertControlToken
    );

    const resolvedParams = mapResolvedParams(apiResolvedParams);

    yield put(setNotificationResolvedParams(resolvedParams));
  } catch (error) {
    yield put(openSnackbarError());
  }
}

export default function* resolvedParamsSagas(): Saga<void> {
  yield takeLatest(RESOLVE_NOTIFICATION_PARAMS, resolveNotificationParamsSaga);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/resolvedParams/sagas.js